iScreenWizard.factory('Testafnamestatus', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('testafnamestatus').then(function (response) {
                var testafnamestatussen = response.data;
                resolve(testafnamestatussen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testafnamestatus/'+id).then(function (response) {
                var testafnamestatus = response.data;
                resolve(testafnamestatus);
            }, reject);
        });
    };

    return data;
});